import { CardWrapper } from "../../../components/CardWrapper/CardWrapper";
import { useSelector } from "../../../hooks";
import { BusinessChars } from "./BusinessChars/BusinessChars";
import { BusinessElements } from "./BusinessElements/BusinessElements";
import { BusinessHeader } from "./BusinessHeader/BusinessHeader";
import { BusinessCard } from "./BusinessCard/BusinessCard";
import { Button } from "../../../components/Buttons/Button/Button";
import styles from "./BusinessDetailPage.module.scss";
import { useNavigate } from "react-router-dom";
import { AppContext } from "../../../components/Menu/MenuButton";

export const BusinessDetailPage = () => {
    const { activeBusiness: business } = useSelector(store => store.businesses);
    const navigate = useNavigate()

    if (!business)
        return <></>;

    const onCloseHandler = () => navigate(`/${AppContext.Office}`);

    return (
        <div className={styles.cardWrapper}>
            <CardWrapper>
                <BusinessCard>
                    <BusinessHeader />
                    <BusinessChars />
                </BusinessCard>

                <BusinessElements />
            </CardWrapper>

            <Button className={styles.button} type='orange' caption='Закрыть' handler={ onCloseHandler } />
        </div>
    );
}